import qs from 'qs';
import { SearchForRetail } from '@/client/api';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
const ANALYTICS_CACHE_TTL_SECONDS = 300;
export const productAnalyticsApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        getProductAnalytics: builder.query({
            query: ({ areaId, productIds }) => {
                const queryString = qs.stringify({ areaId, productIds }, { arrayFormat: 'comma' });
                return {
                    url: `/${SearchForRetail.ANALYTICS_PATH}/productMetrics?${queryString}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => {
                var _a;
                const analytics = Array.isArray(response) ? response : (_a = response.result) !== null && _a !== void 0 ? _a : [];
                return Object.fromEntries(analytics.map((item) => [item.productId, item]));
            },
            serializeQueryArgs: ({ queryArgs }) => {
                const sortedIds = [...queryArgs.productIds].sort();
                return `${queryArgs.areaId}-${sortedIds.join(',')}`;
            },
            providesTags: [CC_API_TAGS.ProductAnalytics],
            keepUnusedDataFor: ANALYTICS_CACHE_TTL_SECONDS,
        }),
    }),
});
export const { useGetProductAnalyticsQuery } = productAnalyticsApi;
